import { Box, Typography } from "@mui/material";
import { dateFormater } from "../../../bmr/utils/common/utils";
import { Tooltip, IconButton } from "@mui/material";
import { EyeIconButton } from "../../../assets/common-svg/CommonSvg"

const SingleToolTip = ({ row, feasibility, status, comment, title, media=[], approvedBy,handleDownload }) => {

 return (
    <Box>
        <div className="p-3" style={{
            backgroundColor: feasibility[status]?.bgColor,
            borderTopRightRadius: '0.75rem',
            borderTopLeftRadius: '0.75rem',
        }}>
            <Typography variant="subtitle2" sx={{ color: feasibility[status]?.text, fontWeight: 'bold' }}>
                {title}
            </Typography>
        </div>
        <div className="p-3 flex flex-col gap-3">
            <Typography variant="body1" className="flex gap-2">
                <span className="text-[#808080]">Feasibility  </span>
                <span>
                    {feasibility[status]?.lable}
                </span>
            </Typography>
            <Typography variant="body1" className="flex gap-2">
                <span className="text-[#808080]">Date  </span>{" "}
                <span>
                    {row?.updated_at && dateFormater(row.updated_at)}
                </span>
            </Typography>
            {title == "Financial Feasibility" && row.financial_payment_type && (
                <Typography variant="body1" className="flex gap-2">
                    <span className="text-[#808080]">Payment Type  </span>{" "}
                    <span>
                        {row.financial_payment_type ?? "- - -"}
                    </span>
                </Typography>
            )}
            <Typography variant="body1" className="flex gap-2">
                <span className="text-[#808080]">Approved By  </span>{" "}
                <span>{approvedBy || "--"}</span>
            </Typography>
            <Typography variant="body1" className="flex flex-col">
                <span className="text-[#808080]">Comment </span>
                <span>{comment || "--"}</span>
            </Typography>
            {media && media?.length > 0 ?
             <Typography variant="body1" className="flex flex-col">
                <span className="text-[#808080]">Files </span>
            {media?.map((fileValues,keyIndex) =>(
            <div  key={'key_'+keyIndex} className="flex mt-2 items-center justify-between bg-gray-100 p-2 rounded">
              <span className="truncate max-w-xs">
                {fileValues.file_name}
              </span>
              <div className="flex gap-2">
                {fileValues?.id && (
                      <Tooltip title="View">
                        <span>
                          <IconButton
                            onClick={() => handleDownload(fileValues?.id)}
                          >
                            <EyeIconButton bgColor={"#3571FF"} />
                          </IconButton>
                        </span>
                      </Tooltip>
                    )}
               
              </div>
            </div>
            )
            )} </Typography>:''}
          
        </div>
    </Box>)
};

export default SingleToolTip;